import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  ALERT_UPDATE_ALERT_SET_BEGIN,
  ALERT_UPDATE_ALERT_SET_SUCCESS,
  ALERT_UPDATE_ALERT_SET_FAILURE,
  ALERT_UPDATE_ALERT_SET_DISMISS_ERROR,
} from './constants';
import { serviceUpdate } from '../../../common/feathers';

export const updateAlertSet = serviceUpdate('alertSets', {
  begin: ALERT_UPDATE_ALERT_SET_BEGIN,
  success: ALERT_UPDATE_ALERT_SET_SUCCESS,
  fail: ALERT_UPDATE_ALERT_SET_FAILURE,
});

export function dismissUpdateAlertSetError() {
  return {
    type: ALERT_UPDATE_ALERT_SET_DISMISS_ERROR,
  };
}

export function useUpdateAlertSet() {
  const dispatch = useDispatch();

  const { updateAlertSetPending, updateAlertSetError } = useSelector(
    state => ({
      updateAlertSetPending: state.alert.updateAlertSetPending,
      updateAlertSetError: state.alert.updateAlertSetError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(updateAlertSet(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUpdateAlertSetError());
  }, [dispatch]);

  return {
    updateAlertSet: boundAction,
    updateAlertSetPending,
    updateAlertSetError,
    dismissUpdateAlertSetError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ALERT_UPDATE_ALERT_SET_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateAlertSetPending: true,
        updateAlertSetError: null,
      };

    case ALERT_UPDATE_ALERT_SET_SUCCESS:
      // The request is success
      return {
        ...state,
        updateAlertSetPending: false,
        updateAlertSetError: null,
        alertSets: (state.alertSets || []).map(alertSet => {
          if (alertSet._id === action.data.id) {
            return action.data.rev;
          }
          return alertSet;
        }
      )
      };

    case ALERT_UPDATE_ALERT_SET_FAILURE:
      // The request is failed
      return {
        ...state,
        updateAlertSetPending: false,
        updateAlertSetError: action.data.error,
      };

    case ALERT_UPDATE_ALERT_SET_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateAlertSetError: null,
      };

    default:
      return state;
  }
}
